// Bind and ReBind All JavaScript by the context location for reloading html dynamically
$(document).ready((): void => {
    BindCommon($(document));
});

function BindCommon($context: JQuery<any>): void {
    BindComponents($context);
    BindEvents($context);
    BindInputMasks($context);
    BindTypeAheads($context);
    CascadeEngine.bind($context);

    /*Prevents jquery validation errors when dynamically inserting fields to DOM (via partial views, AJAX, etc.)
    Uncaught TypeError: Cannot read properties of undefined(reading 'settings') jquery.validate.js:421*/
    $.validator.unobtrusive.parse($context.closest('form'));
}

//TODO: Delete Once the other files are converted to TypeScript
declare function BindInputMasks(context: JQuery<any>): void;
